/**
 * Scroll-reveal: fades and rises each homepage/content section into view
 * once (IntersectionObserver, threshold 0.2, rootMargin "0px 0px -10% 0px",
 * ~900ms ease-out, fires once). Vanilla JS, no dependencies. Progressive
 * enhancement: if this script fails to run, sections stay visible
 * (see assets/scroll-reveal.css).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var root = document.getElementById('MainContent');
  if (!root) return;

  document.documentElement.classList.add('scroll-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  function observeAll(scope) {
    scope.querySelectorAll('.shopify-section').forEach(function (section) {
      observer.observe(section);
    });
  }

  observeAll(root);

  // Shopify re-renders sections over AJAX (variant changes, cart/section
  // updates). When that swaps in a fresh section node, it won't carry the
  // "revealed" class from a prior observation, so watch for new/replaced
  // sections and observe them too — this only ever risks a section
  // re-playing its fade-in, never getting stuck invisible.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.shopify-section')) observer.observe(node);
        if (node.querySelectorAll) observeAll(node);
      });
    });
  }).observe(root, { childList: true, subtree: true });
})();
